<template>
  <div>
    <header class="ts-app-header capture-shell sga-header">
      <a href="/jobseeker-dashboard" class="logo">
        <img src="~../assets/img/logo.svg" alt="TalentSensus" class="logo_icon" />
      </a>
      <div class="ts-app-header--actions">
        <div class="ts-app-header--actions_logout">
          <span @click="doLogout()"><lock-icon size="1.5x"></lock-icon></span>
        </div>
      </div>
    </header>

    <main class="ts-app-capture sga">
      <router-view></router-view>
    </main>

    <!-- Negate the isValidSession value of false to show the session update modal -->
    <SessionUpdate
      :showModal="!isValidSession"
      @close-modal="closeSessionUpdateModal"
    />

  </div>
</template>

<script>
import { LockIcon } from 'vue-feather-icons';
import SessionUpdate from "@/components/SessionUpdate.vue";
import loginUtils from "@/utils/login.utils";

export default {
  components: {
    LockIcon,
    SessionUpdate
  },
  data() {
    return {
      isValidSession: loginUtils.checkLoginStatus(),
    };
  },
  computed: {
    sessionChecker() {
      return process.env.VUE_APP_SESSION_CHECKER_INTERVAL;
    },
  },
  methods: {
    doLogout() {
      this.$store.dispatch('account/logout')
        .then((res) => {
          // this.$router.push({ name: 'Login' });
          // sessionStorage.removeItem('debugid');
           var envi = window.location.host.split('.');
          var suffix, socket;
          if(envi[envi.length - 1] == 'test:5002'){
            suffix = 'test:5002';
            socket = 'http';
          }else{
            suffix = envi[envi.length - 1]
            socket = 'https';
          }
          var website_uri = socket + '://' + envi[envi.length - 2] + '.' + suffix;
           window.location = website_uri+ '/Login/';
        });
    },
    closeSessionUpdateModal() {
      this.isValidSession = true;
    },
  },
  mounted() {
    setInterval(() => {
      this.isValidSession = loginUtils.checkLoginStatus();
    }, this.sessionChecker); // Check every set time for login status
  },
};
</script>